import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { fadeInUpVariants } from '../../hooks/useScrollAnimation';

const EducationSection = styled.section`
  padding: ${({ theme }) => theme.spacing.section} ${({ theme }) => theme.spacing.xl};
  max-width: ${({ theme }) => theme.maxWidth};
  margin: 0 auto;
  border-top: 1px solid ${({ theme }) => theme.colors.border};

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: ${({ theme }) => theme.spacing.xxxl} ${({ theme }) => theme.spacing.lg};
  }
`;

const SectionHeader = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.xxxl};

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    margin-bottom: ${({ theme }) => theme.spacing.xxl};
  }
`;

const Kicker = styled.span`
  font-family: ${({ theme }) => theme.fonts.mono};
  font-size: 0.875rem;
  color: ${({ theme }) => theme.colors.primary};
  letter-spacing: 2px;
  text-transform: uppercase;
  display: block;
  margin-bottom: ${({ theme }) => theme.spacing.sm};
`;

const SectionTitle = styled(motion.h2)`
  font-size: clamp(2.5rem, 5vw, 4rem);
  font-weight: 700;
  font-family: ${({ theme }) => theme.fonts.display};
  color: ${({ theme }) => theme.colors.text};
  line-height: 1.1;
  margin-bottom: ${({ theme }) => theme.spacing.lg};
`;

const EducationCard = styled(motion.div)`
  max-width: 800px;
  padding: ${({ theme }) => theme.spacing.xxxl};
  background: ${({ theme }) => theme.colors.surface};
  border: 1px solid ${({ theme }) => theme.colors.border};
  position: relative;
  transition:
    border-color 0.3s ease,
    background-color 0.3s ease;

  &:hover {
    border-color: ${({ theme }) => theme.colors.primary};
    background: ${({ theme }) => theme.colors.card};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: ${({ theme }) => theme.spacing.xl};
  }
`;

const Degree = styled.h3`
  font-size: clamp(1.5rem, 3vw, 2rem);
  font-weight: 700;
  color: ${({ theme }) => theme.colors.text};
  font-family: ${({ theme }) => theme.fonts.display};
  margin-bottom: ${({ theme }) => theme.spacing.md};
  line-height: 1.2;
`;

const School = styled.h4`
  font-size: 1.25rem;
  color: ${({ theme }) => theme.colors.primary};
  margin-bottom: ${({ theme }) => theme.spacing.sm};
  font-weight: 500;
  font-family: ${({ theme }) => theme.fonts.body};
`;

const Period = styled.span`
  font-family: ${({ theme }) => theme.fonts.mono};
  font-size: 0.875rem;
  color: ${({ theme }) => theme.colors.textSecondary};
  margin-bottom: ${({ theme }) => theme.spacing.lg};
  display: block;
`;

const Description = styled.p`
  font-size: 1.125rem;
  color: ${({ theme }) => theme.colors.textSecondary};
  line-height: 1.7;
`;

const Education: React.FC = () => {
  return (
    <EducationSection id="education">
      <SectionHeader>
        <Kicker>Background</Kicker>
        <SectionTitle
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={fadeInUpVariants}
        >
          Education
        </SectionTitle>
      </SectionHeader>

      <EducationCard
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={fadeInUpVariants}
      >
        <Degree>Bachelor of Computer Science</Degree>
        <School>VNU University of Engineering and Technology</School>
        <Period>2017 — 2021</Period>
        <Description>
          My journey at VNU University of Engineering and Technology laid the crucial foundation for
          who I am today. Through comprehensive Computer Science education, I discovered my passion
          for mobile development and modern technologies. Grateful for the knowledge, opportunities,
          and guidance that shaped my path toward becoming a skilled software engineer.
        </Description>
      </EducationCard>
    </EducationSection>
  );
};

export default Education;
